import { DashboardOutlined } from '@ant-design/icons-vue'

/**
 * 团安智慧大屏路由配置
 * 独立的智慧大屏模块，与其他大屏组件隔离
 */
export default [
  {
    path: '/screen/tuanan',
    name: 'tuananScreen',
    component: () => import('@/views/screen/tuanan/index.vue'),
    meta: {
      title: '团安智慧大屏',
      icon: DashboardOutlined,
      isFullScreen: true, // 全屏显示
      keepAlive: false,
      hidden: false,
      prem: true,
      sort: 99, // 排序靠后
    },
  },
]
